import { render, staticRenderFns } from "./exhibition-scan-revise.vue?vue&type=template&id=5adc8b3c&scoped=true&"
import script from "./exhibition-scan-revise.vue?vue&type=script&lang=js&"
export * from "./exhibition-scan-revise.vue?vue&type=script&lang=js&"
import style0 from "./exhibition-scan-revise.vue?vue&type=style&index=0&id=5adc8b3c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5adc8b3c",
  null
  
)

export default component.exports